<i18n>
  {
    "fr": {
      "link": "Consulter les tâches à faire"
    },
    "en": {
      "link": "View tasks to do"
    }
  }
</i18n>
<template>
  <div class="card" :class="{ 'mt-24px': $media.mobile, 'mt-32px': $media.tablet, 'mt-40px': $media.widescreen }">
    <ui-box>
      <h2 class="title is-4 has-text-weight-bold mb-0">{{ title }}</h2>
      <p class="mt-12px mb-32px">{{ text }}</p>
      <div class="columns">
        <ul class="column">
          <li v-for="item of badges" :key="item.text" class="mb-12px">
            <ui-bar-element
              type="label-item"
              :text="item.text"
              :count="item.count"
              :color="item.color"
              :icon="item.icon"
              :isSpecific="item.count === 0"
            />
          </li>
        </ul>
        <div class="column">
          <donut-chart :size="200" :sectors="sectors">
            <strong class="is-size-2 has-text-weight-normal"> {{ donePercent }}% </strong>
            <div class="has-text-weight-bold">
              <status-badge class="mx-12px" :badge="doneBadge.icon" :hide-not-applicable="false" :show-label="true" />
            </div>
          </donut-chart>
        </div>
      </div>
      <p v-if="!!link" class="has-text-centered">
        <router-link :to="link" class="has-text-underline">
          {{ link.text }}
        </router-link>
      </p>
    </ui-box>
  </div>
</template>

<script>
import IndicatorHelper from '@/helpers/indicator-helper'

import UiBox from '@/components/ui/box'
import UiBarElement from '@/components/ui/bar-element'
import DonutChart from './donut-chart'
import StatusBadge from '@/components/indicator/status-badge'

export default {
  components: { UiBox, UiBarElement, DonutChart, StatusBadge },
  props: {
    title: { type: String },
    text: { type: String },
    link: { type: Object },
    doneCount: { type: Number },
    inProgressCount: { type: Number },
    todoCount: { type: Number },
    notApplicableCount: { type: Number }
  },
  computed: {
    // Badges
    badges() {
      return [this.doneBadge, this.inProgressBadge, this.todoBadge, this.notApplicableBadge]
    },
    todoBadge() {
      const badgeDefinition = IndicatorHelper.badges().badgeTodo
      return {
        count: this.todoCount,
        text: badgeDefinition.label,
        color: 'warning',
        icon: {
          ...badgeDefinition
        }
      }
    },
    inProgressBadge() {
      const badgeDefinition = IndicatorHelper.badges().badgeInProgress
      return {
        count: this.inProgressCount,
        text: badgeDefinition.label,
        color: 'primary-dark',
        icon: {
          ...badgeDefinition
        }
      }
    },
    doneBadge() {
      const badgeDefinition = IndicatorHelper.badges().badgeDone
      return {
        count: this.doneCount,
        text: badgeDefinition.label,
        color: 'success-dark',
        icon: {
          ...badgeDefinition,
          color: 'success-dark'
        }
      }
    },
    notApplicableBadge() {
      const badgeDefinition = IndicatorHelper.badges().badgeNotApplicable
      return {
        count: this.notApplicableCount,
        text: badgeDefinition.label,
        color: 'grey-dark',
        icon: {
          ...badgeDefinition
        }
      }
    },

    // Counts and percentages
    todoPercent() {
      if (!this.totalCount) return 100
      return Math.round((this.todoCount / this.totalCount) * 100)
    },
    inProgressPercent() {
      if (!this.totalCount) return 100
      return Math.round((this.inProgressCount / this.totalCount) * 100)
    },
    donePercent() {
      if (!this.totalCount) return 100
      return Math.round((this.doneCount / this.totalCount) * 100)
    },
    notApplicablePercent() {
      if (!this.totalIndicators) return 100
      return Math.round((this.notApplicableCount / this.totalIndicators) * 100)
    },
    totalCount() {
      return this.doneBadge.count + this.inProgressBadge.count + this.todoBadge.count
    },

    // Sectors
    sectors() {
      return [
        {
          value: this.doneBadge.count,
          label: this.doneBadge.text,
          color: 'rgb(22, 131, 60)'
        },
        {
          value: this.inProgressBadge.count,
          label: this.inProgressBadge.text,
          color: 'rgb(31, 73, 234)'
        },
        {
          value: this.todoBadge.count,
          label: this.todoBadge.text,
          color: 'rgb(228, 150, 31)'
        }
      ]
    }
  }
}
</script>